export enum ReduxActionType {
  SET_LAST_ODDS = "SET_LAST_ODDS",
  POLL = "POLL",
  SET_MATCH = "SET_MATCH",
  GET_MATCH_AND_SPONSOR = "GET_MATCH_AND_SPONSOR",
  SET_HOME_STATS = "SET_HOME_STATS",
  SET_AWAY_STATS = "SET_AWAY_STATS",
}
